const PostsCatDropdown = () => {

  const catSelector = document.getElementById("post-category-selector-btn");
  const catDropdown = document.getElementById("post-category-selector-dropdown");
  
  if (!catSelector || !catDropdown) {
		return;
	}


  catSelector.addEventListener("click", function(e) {

    catSelector.classList.toggle("is-active");
    catDropdown.classList.toggle("is-active");
    // update_aria_labels(search_toggle)

    // setTimeout(() => {
    //   search_form.querySelector("input").focus();
    // }, 100); // has a default time value of 0
  
  });

}

export { PostsCatDropdown };